import TutorDataApiUtils from '../utils/api/tutorData';
// import {addMessage as addFlashMessage} from './flash';

export const FETCH_TUTOR_ISSUE_RATE_SENT = 'FETCH_TUTOR_ISSUE_RATE_SENT';
export const FETCH_TUTOR_ISSUE_RATE_SUCCEEDED =
  'FETCH_TUTOR_ISSUE_RATE_SUCCEEDED';
export const FETCH_TUTOR_ISSUE_RATE_FAILED = 'FETCH_TUTORS_FAILED';
export const FETCH_TUTOR_SUBSCRIBE_RATE_SENT =
  'FETCH_TUTOR_SUBSCRIBE_RATE_SENT';
export const FETCH_TUTOR_SUBSCRIBE_RATE_SUCCEEDED =
  'FETCH_TUTOR_SUBSCRIBE_RATE_SUCCEEDED';
export const FETCH_TUTOR_SUBSCRIBE_RATE_FAILED =
  'FETCH_TUTOR_SUBSCRIBE_RATE_FAILED';

export function fetchIssueRateSent() {
  return {
    type: FETCH_TUTOR_ISSUE_RATE_SENT,
  };
}

export function fetchIssueRateSucceeded(data) {
  return {
    type: FETCH_TUTOR_ISSUE_RATE_SUCCEEDED,
    payload: data,
  };
}

export function fetchIssueRateFailed(error) {
  return {
    type: FETCH_TUTOR_ISSUE_RATE_FAILED,
  };
}

export function fetchIssueRate() {
  return (dispatch) => {
    dispatch(fetchIssueRateSent());
    return TutorDataApiUtils.fetchIssueRate().then(
      (data) => dispatch(fetchIssueRateSucceeded(data)),
      (error) => dispatch(fetchIssueRateFailed(error)),
    );
  };
}

export function fetchSubscribeRateSent() {
  return {
    type: FETCH_TUTOR_SUBSCRIBE_RATE_SENT,
  };
}

export function fetchSubscribeRateSucceeded(data) {
  return {
    type: FETCH_TUTOR_SUBSCRIBE_RATE_SUCCEEDED,
    payload: data,
  };
}

export function fetchSubscribeRateFailed(error) {
  return {
    type: FETCH_TUTOR_SUBSCRIBE_RATE_FAILED,
  };
}

export function fetchSubscribeRate() {
  return (dispatch) => {
    dispatch(fetchSubscribeRateSent());
    return TutorDataApiUtils.fetchSubscribeRate().then(
      (data) => dispatch(fetchSubscribeRateSucceeded(data)),
      (error) => dispatch(fetchSubscribeRateFailed(error)),
    );
  };
}
